<template>
  <div class="coupon-container">
    <div class="coupon-top-title">工会会员全年福利计划</div>
    <div class="coupon-nav-container">
      <div class="coupon-nav-item">工会会员平台激活好礼 ></div>
      <div class="coupon-nav-item">全年福利计划 ></div>
    </div>

    <van-swipe class="coupon-swipe" :autoplay="5000" indicator-color="#595757">
      <van-swipe-item v-for="i in coupons.length" :key="i">
        <div class="coupon-list">
          <div class="coupon-item" v-for="(item, ii) in coupons[i - 1]" :key="ii" @click="takeCoupon(item)">
            <div class="coupon-item-left">
              <div>{{ item.categoryName }}</div>
              <van-icon
                :name="require(`@/assets/images/puhui/c${item.categoryId}.png`)"
                v-if="item.categoryId > 0 && item.categoryId < 5"
              />
            </div>
            <div class="coupon-item-right">
              <div class="coupon-title">
                <span class="coupon-title-left">{{ item.name }}</span>
                <span class="coupon-title-right" v-if="item.take"> 可用{{ item.remainingUsageCount }}次 </span>
                <span class="coupon-title-right" v-else> 限领{{ item.count }}张 </span>
              </div>
              <div class="coupon-meta">
                <div>
                  <div class="coupon-meta--title">累计福利</div>
                  <div class="coupon-meta--value">
                    {{ (item.usageCount - (item.remainingUsageCount || 0)) * item.preferentialContent }}(元)
                  </div>
                </div>
                <div class="coupon-meta--times">
                  {{ item.usageCount }}次/{{ item.endTime | calculationDuration(item.startTime) }}天
                </div>
                <div>
                  <div class="coupon-meta--title">封顶消费</div>
                  <div class="coupon-meta--value">{{ item.preferentialContent }}元/次</div>
                </div>
              </div>
              <div class="coupon-footer">服务商家：{{ item.merchantName }}</div>
            </div>
          </div>
        </div>
      </van-swipe-item>
    </van-swipe>

    <van-empty
      v-show="isEmpty"
      class="coupon-empty"
      :image="require('@/assets/images/puhui/sy-w1.png')"
      description="暂无数据~"
    />
  </div>
</template>

<script>
import moment from 'moment'
import { getGHCoupons, takeCouponBatch } from '@/api/coupon'

export default {
  name: 'CouponPanel',
  data() {
    return {
      coupons: [],
      isEmpty: false
    }
  },
  filters: {
    calculationDuration: (endTime, startTime) => moment(endTime).diff(moment(startTime), 'day')
  },
  mounted() {
    this.loadCoupons()
  },
  methods: {
    /**
     * 加载优惠券
     */
    loadCoupons() {
      getGHCoupons({
        limit: 12
      }).then(res => {
        const data = res.data.data

        if (data.length === 0) {
          this.isEmpty = true
          return
        }

        const result = []
        for (let i = 0, len = data.length; i < len; i += 3) {
          result.push(data.slice(i, i + 3 > len ? len : i + 3))
        }
        this.coupons = result
      })
    },

    /**
     * 领取优惠券
     */
    takeCoupon(item) {
      if (item.take) {
        this.$router.push({
          path: '/product-coupon',
          query: {
            couponId: item.couponId,
            preferentialContent: item.preferentialContent,
            useThreshold: item.useThreshold
          }
        })
      } else {
        takeCouponBatch([item.id]).then(res => {
          if (res.data.code === 200) {
            this.$toast.success('领取成功')
            this.loadCoupons()
          } else {
            this.$toast.fail(result.msg)
          }
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.coupon {
  &-container {
    padding-bottom: 10px;
  }

  &-top-title {
    margin: 14px 0 10px 0;
    font-size: 18px;
    font-weight: 600;
    text-align: center;
  }

  &-nav {
    &-container {
      padding: 0 12px;
      display: flex;
      justify-content: space-between;
    }

    &-item {
      height: 40px;
      width: 170px;
      color: #fff;
      font-size: 14px;
      text-align: center;
      line-height: 40px;
      background-color: #ffae43;
    }
  }

  &-swipe {
    .van-swipe__indicators {
      bottom: 0;
    }
  }

  &-list {
    padding: 0 12px 16px 12px;
  }

  &-item {
    height: 102px;
    margin-top: 8px;
    display: flex;
    border-radius: 5px;

    font-size: 12px;
    background-color: #fffbf5;
    overflow: hidden;

    &-left {
      width: 48px;
      height: 100%;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      color: #fff;
      font-size: 14px;
      background-repeat: no-repeat;
      background-position: 50% 50%;
      background-size: 100%;

      img {
        margin-top: 10px;
        width: 20px;
        height: 20px;
      }
    }

    &:nth-child(2n) .coupon-item-left {
      background-image: url('~@/assets/images/puhui/cheng.png');
    }

    &:nth-child(2n -1) .coupon-item-left {
      background-image: url('~@/assets/images/puhui/lan.png');
    }

    &:nth-child(2n) .coupon-meta--value {
      color: #ffae43;
    }

    &:nth-child(2n -1) .coupon-meta--value {
      color: #22b573;
    }

    &-right {
      width: 303px;
      position: relative;
    }
  }

  &-title {
    width: 100%;
    height: 32px;
    line-height: 32px;
    position: relative;
    background-color: #fff3de;

    &-left {
      font-size: 15px;
      margin-left: 10px;
    }

    &-right {
      position: absolute;
      height: 26px;
      top: 3px;
      right: 6px;
      padding: 0 6px;
      color: #fff;
      line-height: 26px;
      border-radius: 4px;
      background-color: #ff7b22;
    }
  }

  &-meta {
    margin-top: 8px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    font-size: 14px;

    & > * {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    &--title {
      color: #999;
    }

    &--times {
      padding: 0 14px;
      color: #231815;
      border-left: 1px solid #dfdedb;
      border-right: 1px solid #dfdedb;
    }
  }

  &-footer {
    position: absolute;
    left: 10px;
    right: 10px;
    bottom: 0;
    padding: 2px 0;
    color: #b5b5b6;
    border-top: 1px solid #e9e8e6;
  }

  &-empty {
    padding: 40px 0 20px 0;
  }
}

/deep/ .van-empty {
  &__image {
    width: 100px;
  }

  &__image,
  &__image img {
    height: auto;
    max-height: 100px;
  }

  &__description {
    font-size: 12px;
    margin-bottom: 0;
  }
}
</style>
